<div>
  <div class="{{ isWebView ? '' : 'container'}} ">
    <div class="container-header {{isWebView ? '' : 'justify-content-center'}}">
      <p class="font-18 {{ isWebView ? 'text-color text-center-start font-weight-600 p10' : 'black-color align-center'}} ">New Payment Option</p>
    </div>
    <div class="{{ isWebView ? 'webview box p10' : ''}}">
      <form [formGroup]="newPaymentInfoForm">
        <div class="row justify-content-center align-items-center">
          <p class="font-12 font-weight-400 {{ isWebView ? 'text-color' : 'red-color'}} ">*Required field
          </p>
          <div class="col-sm-6">
            <div class="form-group">
              <label class="form-group {{ isWebView ? 'wv-text wv-required' : 'desktop-text required'}}">Billing
                Address</label>
              <input type="text" class="form-control {{isWebView && isAcura ? 'wv-text AcuraPlaceholder' : ''}} {{isWebView && !isAcura ? 'wv-text HondaPlaceholder' : ''}}"
                placeholder="Enter Billing Address" formControlName="billingAddress" [ngClass]="
              ((newPaymentInfoForm.get('billingAddress')?.touched ||
                newPaymentInfoForm.get('billingAddress')?.dirty) &&
              newPaymentInfoForm.get('billingAddress')?.hasError('required')
                ? 'is-invalid'
                : '') ||
                  (((newPaymentInfoForm.get('billingAddress')?.touched ||
                    newPaymentInfoForm.get('billingAddress')?.dirty) &&
                    !newPaymentInfoForm.get('billingAddress')?.invalid)
                ? 'is-valid'
                : '')
            " />
              <div class="invalid-feedback">
                {{
                newPaymentInfoForm.get("billingAddress")?.hasError("required")
                ? " Billing address is required"
                : ""
                }}
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label class="form-group {{ isWebView ? 'wv-text' : 'desktop-text'}}">Apt / Suite / Other / (Optional)</label>
              <input type="text" placeholder="Enter Apt / Suite / Other"
              class="form-control {{isWebView && isAcura ? 'wv-text AcuraPlaceholder' : ''}} {{isWebView && !isAcura ? 'wv-text HondaPlaceholder' : ''}}" formControlName="aptOrSuite" />
            </div>
          </div>

          <div class="col-sm-6">
            <div class="form-group">
              <label
              class="form-group {{ isWebView ? 'wv-text wv-required' : 'desktop-text required'}}">Zip
                Code</label>
              <input type="text" class="form-control {{isWebView && isAcura ? 'wv-text AcuraPlaceholder' : ''}} {{isWebView && !isAcura ? 'wv-text HondaPlaceholder' : ''}}"
                placeholder="Enter Zip Code" formControlName="zipCode" [ngClass]="
              ((newPaymentInfoForm.get('zipCode')?.touched ||
                newPaymentInfoForm.get('zipCode')?.dirty) &&
              newPaymentInfoForm.get('zipCode')?.hasError('required') ||
              newPaymentInfoForm.get('zipCode')?.hasError('zipNotValid')
                ? 'is-invalid'
                : '') ||
                  (((newPaymentInfoForm.get('zipCode')?.touched ||
                    newPaymentInfoForm.get('zipCode')?.dirty) &&
                    !newPaymentInfoForm.get('zipCode')?.invalid)
                ? 'is-valid'
                : '')
            " />
              <div class="invalid-feedback">
                {{
                newPaymentInfoForm.get("zipCode")?.hasError("required")
                ? "ZipCode is required"
                : ""
                }}
                {{
                newPaymentInfoForm.get("zipCode")?.hasError("zipNotValid")
                ? "Enter a valid zip code (XXXXX or XXXXX-XXXX)"
                : ""
                }}
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label
              class="form-group {{ isWebView ? 'wv-text wv-required' : 'desktop-text required'}}">City</label>
              <input type="text" placeholder="Enter City"
              class="form-control {{isWebView && isAcura ? 'wv-text AcuraPlaceholder' : ''}} {{isWebView && !isAcura ? 'wv-text HondaPlaceholder' : ''}}" formControlName="city" [ngClass]="
              ((newPaymentInfoForm.get('city')?.touched ||
                newPaymentInfoForm.get('city')?.dirty) &&
              newPaymentInfoForm.get('city')?.hasError('required')
                ? 'is-invalid'
                : '') ||
                  (((newPaymentInfoForm.get('city')?.touched ||
                    newPaymentInfoForm.get('city')?.dirty) &&
                    !newPaymentInfoForm.get('city')?.invalid)
                ? 'is-valid'
                : '')
            " />
              <div class="invalid-feedback">
                {{
                newPaymentInfoForm.get("city")?.hasError("required")
                ? "City is required"
                : ""
                }}
              </div>
            </div>
          </div>

          <div class="col-sm-6">
            <div class="form-group">
              <label
              class="form-group {{ isWebView ? 'wv-text wv-required' : 'desktop-text required'}}">State</label>
              <select class="form-select {{isWebView && isAcura ? 'wv-text AcuraDropdown' : ''}} {{isWebView && !isAcura ? 'wv-text HondaDropdown' : ''}}"
                formControlName="selectedState">
                <option disabled selected hidden [value]="null" style="display:none">Select State</option>
                <option *ngFor="let state of stateProvDropdown; trackBy: trackByState" [value]="state.value">
                  {{ state.displayValue }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="{{isWebView && isAcura ? 'check-wv acura-webview-checkbox' : isWebView ? 'check-wv honda-webview-checkbox' : 'check'}}">
              <mat-checkbox class="checkbox black-color"
                (change)="checkDefaultPaymentCheckBox($event)" [checked]="paymentOptionsLength === 0"
                [disabled]="paymentOptionsLength === 0">Set as Default
                Payment Option
              </mat-checkbox>
            </div>
            <!-- <div class="check col-sm-6">
          <mat-checkbox class="checkbox">Set as Default Address</mat-checkbox>
        </div> -->
          </div>
          <div class="col-sm-12">
            <div class="check {{isWebView && isAcura ? 'wv acura-webview-checkbox' : isWebView ? 'wv honda-webview-checkbox' : ''}}">
              <mat-checkbox class="checkbox black-color"
                (change)="checkDefaultAddressCheckBox($event)">Set as Default Address
              </mat-checkbox>
            </div>
          </div>
        </div>
      </form>

      <div class="private-policy {{ isWebView ? 'justify-content-left' : 'mt-5 justify-content-center'}}">
        <p class="font-14 {{ isWebView ? 'text-color' : 'black-color'}}">
          To learn more about how we collect and use personal information, please
          read our <a href="https://www.honda.com/privacy/privacy-notice" target="{{isWebView ? '_self' : '_blank'}}">
            Privacy Notice</a>.
        </p>
      </div>
    </div>
    <div class="p10">
      <div *ngIf="!isWebView" class="action-btn-container flex justify-content-center" [formGroup]="newPaymentInfoForm">
        <button mat-flat-button class="edit-form-button standard-btn danger-btn btn-width hover" (click)="onBack()">
          Back
        </button>
        <button mat-flat-button class="edit-form-button standard-btn primar-btn btn-width"
          [disabled]="newPaymentInfoForm.invalid" (click)="onNext()">
          Next
        </button>
      </div>
      <div *ngIf="isWebView" class="container-buttons-wv flex-column-wv justify-content-center"
        [formGroup]="newPaymentInfoForm">
        <button mat-flat-button class="button-with-radius standard-btn webview-btn {{isAcura ? 'AcuraBtn-disabled' : 'HondaBtn-disabled'}}"
          [disabled]="newPaymentInfoForm.invalid" (click)="onNext()">
          Next
        </button>
        <button mat-flat-button class="button-wv standard-btn" (click)="onBack()">
          Back
        </button>
      </div>
    </div>
  </div>
</div>
